import { ReactElement } from "react";
import { Dropdown } from "react-bootstrap";
import { CopyItem } from "./CopyItem";
import { CustomToggle } from "./CustomToggle";
import { DeleteItem } from "./DeleteItem";
import { OrderItem } from "./OrderItem";
import { SaveAsBlockItem } from "./SaveAsBlockItem";
import { DuplicateItem } from "./DuplicateItem";
import { PasteItem } from "./PasteItem";
import { Container } from "@/backend/models/containers/container";
import { Operation } from "@/backend/models/operation";
import { CopyPasteTypes } from "@/types/copyPasteTypes";

export interface DropdownMenuProps<T> {
  instance: CopyPasteTypes;
  onClickDelete: () => Promise<void>;
  onClickDupe: () => void;
  saveAsBlock: (title: string) => void;
  orderItems: (model: T[]) => Promise<void>;
  listOfItems: T[];
  children?: ReactElement[];
  item: Operation | Container;
}

export const DropdownMenu = <T extends Operation | Container>(props: DropdownMenuProps<T>) => {
  const { instance, onClickDelete, orderItems, onClickDupe, saveAsBlock, listOfItems = [], children = [], item } = props;
  return (
    <Dropdown drop='down'>
      <Dropdown.Toggle size='sm' as={CustomToggle(instance)} variant='dark' id="dropdown-basic" />
      <Dropdown.Menu>
        <OrderItem listOfItems={listOfItems} orderItems={orderItems} instance={instance} />
        <DuplicateItem onClickDupe={onClickDupe} />
        <CopyItem instance={instance} itemId={item.id} />
        <PasteItem item={item} instance={instance} isScaffold={item.isScaffold} />
        {children}
        <SaveAsBlockItem defaultTitle={item.title} saveBlock={saveAsBlock} />
        <DeleteItem deleteAction={onClickDelete} itemType={instance} title={item.title} />
      </Dropdown.Menu>
    </Dropdown>
  );
};
